import styled from 'styled-components';

export const Subtitle = styled.h3`
  margin-bottom: 10px;
`;
